import React, { useState, useEffect } from 'react';
import moment from 'moment';

import './SystemStatus.css';

const SystemStatus = props => {
  const [statusDate, setStatusDate] = useState('Unknown');

  useEffect(() => {
    const url = `${process.env.REACT_APP_PORTAL_API}v1/pdt-status-check`;

    const fetchData = async () => {
      try {
        const response = await fetch(url);
        const json = await response.json();
        if (json.success === true) {
          setStatusDate(
            moment(json.data.date)
              .utc()
              .format('MMMM DD, YYYY')
          );
        }
      } catch (error) {
        console.log('error', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="tvt-systemstatus">
      Data available through <strong>{statusDate}</strong>
      <div>
        <a href="/system-status">See System Status</a>
      </div>
    </div>
  );
};

export default SystemStatus;
